import { classNames } from '@/utils/classNames';

type AlbumCardPlaceholderProps = {
    className?: string;
};

const AlbumCardPlaceholder = ({ className = '' }: AlbumCardPlaceholderProps) => {
    return (
        <div
            className={classNames('h-full w-full', className)}
            data-testid="album-card-placeholder">
            <div className="flex h-full w-full flex-col space-y-5 overflow-hidden rounded-md bg-white px-3 pt-3 dark:bg-icoDarkMode-anthracite">
                {/* Header - Media Grid Placeholder */}
                <div className="relative h-64 w-full animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />

                {/* Content + Footer wrapper */}
                <div className="flex flex-1 flex-col justify-between space-y-m pb-3">
                    {/* Content - Title and Count Placeholder */}
                    <div className="flex flex-col items-center space-y-2">
                        <div className="h-7 w-3/4 animate-pulse rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                        <div className="h-4 w-1/2 animate-pulse rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                    </div>

                    {/* Footer - Analytics Placeholder */}
                    <div>
                        <div className="mb-m h-px w-auto bg-icoGray-300 dark:bg-icoDarkMode-beton" />
                        <div className="mb-m flex w-auto justify-center space-x-4">
                            {[1, 2, 3].map((item) => (
                                <div key={item} className="flex items-center space-x-2">
                                    <div className="h-4 w-4 animate-pulse rounded-full bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                                    <div className="h-4 w-12 animate-pulse rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlbumCardPlaceholder;
